export default __webpack_public_path__ + "static/media/clobber1.113316c5.png";